import { moneyDisplay, qtyDisplay } from "@icraftx/shared/v1";
import { DocLetterhead } from "./DocLetterhead";
import {
  formatDocIssuedAt,
  type DocPrintData,
} from "./doc-print-math";
import type { LetterheadPrint } from "./letterhead-print-math";

export function DocSlip({
  data,
  letterhead,
}: {
  data: DocPrintData;
  /** Org print profile — plan/43. Omit → legacy title-only header. */
  letterhead?: LetterheadPrint | null;
}) {
  return (
    <article className="pos-receipt font-mono text-[12px] leading-snug text-black">
      {letterhead ? <DocLetterhead letterhead={letterhead} /> : null}
      <header className="text-center">
        <div className="text-[11px] uppercase tracking-wider">{data.title}</div>
        <div className="mt-1 text-[14px] font-bold tracking-wide">
          {data.number}
        </div>
        <div className="mt-2 text-[11px]">
          {data.partyLabel}: {data.partyName}
        </div>
        <div className="mt-1 text-[10px]">{data.statusLine}</div>
        <div className="mt-1 text-[10px]">
          {formatDocIssuedAt(data.issuedAt)}
        </div>
      </header>

      <div className="my-3 border-t border-dashed border-black/40" />

      <ul className="m-0 list-none space-y-2 p-0">
        {data.lines.map((line, i) => {
          const isGl =
            line.debit != null || line.credit != null;
          return (
            <li key={`${line.name}-${i}`}>
              <div className="font-sans text-[12px] font-medium">
                {line.name}
              </div>
              <div className="flex justify-between gap-2">
                {isGl ? (
                  <>
                    <span>
                      {line.debit != null
                        ? `Dr ₱${moneyDisplay(line.debit)}`
                        : `Cr ₱${moneyDisplay(line.credit!)}`}
                    </span>
                    <span />
                  </>
                ) : (
                  <>
                    <span>
                      {qtyDisplay(line.qty)} × ₱
                      {moneyDisplay(line.unitPrice)}
                    </span>
                    <span>₱{moneyDisplay(line.lineTotal)}</span>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ul>

      <div className="my-3 border-t border-dashed border-black/40" />

      <div className="space-y-1">
        {data.totals.map((t) => (
          <div
            key={t.label}
            className={
              t.label === "Total"
                ? "flex justify-between text-[13px] font-bold"
                : "flex justify-between"
            }
          >
            <span>{t.label}</span>
            <span>{t.value}</span>
          </div>
        ))}
      </div>

      {data.footerNote && (
        <footer className="mt-4 text-center text-[10px]">
          {data.footerNote}
        </footer>
      )}
    </article>
  );
}

export function printDocSlip(): void {
  window.print();
}
